// Reserves the address-input footprint so the dynamically-imported input and its
// SSR placeholder occupy the same height and don't shift layout. The submit
// button sits beside the field on wider screens and stacks under it below 480px,
// which is where the taller reservation comes from.
export const CASH_OFFER_ADDRESS_INPUT_MIN_HEIGHT_CLASS = 'min-h-[124px] min-[481px]:min-h-14';
